"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldComputedMapEvaluator = exports.fieldOptionsMapEvaluator = exports.fieldWarningMapEvaluator = exports.formWarningMapEvaluator = exports.fieldErrorMapEvaluator = exports.formErrorMapEvaluator = exports.evaluator = void 0;
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
// Common generic function used for all evaluation types
const evaluator = (accessors, evaluate, key, configFunctions, maps, skipFilter) => {
    if (!maps) {
        return Promise.resolve([]);
    }
    const promises = maps.map(currentMap => evaluate(currentMap, accessors, configFunctions));
    return Promise.all(promises).then(promiseResults => {
        return promiseResults
            .map(result => result[key])
            .filter(msg => skipFilter || (typeof msg === 'string' && msg.length));
    });
};
exports.evaluator = evaluator;
// Error maps
const formErrorMapEvaluator = (accessors, configFunctions, errorMaps) => {
    return exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.FORM_LEVEL_ERROR.evaluate, 'errorMessage', configFunctions, errorMaps);
};
exports.formErrorMapEvaluator = formErrorMapEvaluator;
const fieldErrorMapEvaluator = (accessors, configFunctions, errorMaps) => {
    return exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.FIELD_LEVEL_ERROR.evaluate, 'errorMessage', configFunctions, errorMaps);
};
exports.fieldErrorMapEvaluator = fieldErrorMapEvaluator;
//Warning Maps
const formWarningMapEvaluator = (accessors, configFunctions, warningMaps) => {
    return exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.FORM_LEVEL_WARNING.evaluate, 'warningMessage', configFunctions, warningMaps);
};
exports.formWarningMapEvaluator = formWarningMapEvaluator;
const fieldWarningMapEvaluator = (accessors, configFunctions, warningMaps) => {
    return exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.FIELD_LEVEL_WARNING.evaluate, 'warningMessage', configFunctions, warningMaps);
};
exports.fieldWarningMapEvaluator = fieldWarningMapEvaluator;
const fieldOptionsMapEvaluator = async (accessors, configFunctions, optionsMap) => {
    if (!optionsMap) {
        return Promise.resolve(undefined);
    }
    return (await exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.DROPDOWN_OPTIONS.evaluate, 'options', configFunctions, [optionsMap], true))[0];
};
exports.fieldOptionsMapEvaluator = fieldOptionsMapEvaluator;
const fieldComputedMapEvaluator = async (accessors, configFunctions, computedMap, skipFilter) => {
    return (await exports.evaluator(accessors, gen5_datamapping_lib_1.mapScenarios.COMPUTED_MAPPING.evaluate, 'result', configFunctions, [computedMap], skipFilter))[0];
};
exports.fieldComputedMapEvaluator = fieldComputedMapEvaluator;
